/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SettingTypeFromJSON, SettingTypeToJSON } from './';
export function SettingRepresentationFromJSON(json) {
    return SettingRepresentationFromJSONTyped(json, false);
}
export function SettingRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        key: SettingTypeFromJSON(json['key']),
        value: json['value'],
    };
}
export function SettingRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        key: SettingTypeToJSON(value.key),
        value: value.value,
    };
}
